<template>
<div  >
    <TestContestList :category="category"   v-if="category" /> 
    <TestContestView v-if="item_id && memberOnly()"  />
</div>
</template>

<script>
import TestContestList from '@/views/TestContest/TestContestList'
import TestContestView from '@/views/TestContest/TestContestView'
export default {

    components: {
        TestContestList,
        TestContestView
    },
    props: {
        category: null, 
    },

    data: () => ({

        data: {}

    }),

    computed: {

    },

    watch: {

    },
    methods: {

   

    },
    created() {

     

    },
};
</script>
